var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSavedraft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 7.423V18.385C20 18.845 19.846 19.2293 19.538 19.538C19.23 19.8467 18.8453 20.0007 18.384 20H5.616C5.15533 20 4.771 19.846 4.463 19.538C4.155 19.23 4.00067 18.8453 4 18.384V5.616C4 5.15533 4.15433 4.771 4.463 4.463C4.77167 4.155 5.156 4.00067 5.616 4H16.577L20 7.423ZM19 7.85L16.15 5H5.616C5.436 5 5.28833 5.05767 5.173 5.173C5.05767 5.28833 5 5.436 5 5.616V18.385C5 18.5643 5.05767 18.7117 5.173 18.827C5.28833 18.9423 5.436 19 5.616 19H18.385C18.5643 19 18.7117 18.9423 18.827 18.827C18.9423 18.7117 19 18.564 19 18.384V7.85ZM12 16.538C12.5513 16.538 13.0227 16.3427 13.414 15.952C13.8053 15.5613 14.0007 15.09 14 14.538C13.9993 13.986 13.8037 13.515 13.413 13.125C13.0223 12.735 12.5513 12.5397 12 12.539C11.4487 12.5383 10.9777 12.7337 10.587 13.125C10.1963 13.5163 10.0007 13.9873 10 14.538C9.99933 15.0887 10.195 15.56 10.587 15.952C10.979 16.344 11.45 16.5393 12 16.538ZM6.77 9.77H14.192V6.77H6.77V9.77ZM5 7.85V19V5V7.85Z",
    fill: "#F93737"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSavedraft);
export default __webpack_public_path__ + "static/media/savedraft.af7b813429b64eb381f76cf5dc05c089.svg";
export { ForwardRef as ReactComponent };